// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"94":"b598bfca","189":"44897b47"}[chunkId] + ".css";
};